<template>
	<div>
		<br />
		<div class="panel panel-blue padding-10-firefox">
			<PanelHeading
				id="myMobileApps"
				:title="'My Projects'"
			>
				<SortingListButton 
					:options="sortingOptions"
					:sortKey="projectsListPagesConfig.myMobileApps.sortKey"
					:orderDesc="projectsListPagesConfig.myMobileApps.orderDesc"
					class="pull-right"
					v-on:sortOrderChanged="changeSortOrder(projectsListsType.myMobileApps, $event)"
				/>
			</PanelHeading>
			<div class="panel-content">
				<div class="panel-body" :class="{loading: !isLoading}">
					<div
						class="whitelabel-add-project"
						v-if="whitelabel && whitelabel.settings.projectCreateAllowed"
					>
						<button class="app-add btn btn-primary"  v-on:click="addProject()">
							<div class="button-text">
								<i class="glyphicon glyphicon-plus"></i>
								Add Project
							</div>
						</button>

						<a ui-sref="listOrders">
							<button class="btn btn-success pull-right">
								<i class="fa fa-usd" aria-hidden="true"></i>
								Orders
							</button>
						</a>
					</div>

					<div class="app-info-wrapper" v-if="!whitelabel">
						<div class="app-info">
							<div class="panel">
								<div class="panel-content">
									<div class="panel-body">
										<div class="row">


											<div class="col-lg-6">

													<div class="row">
															<div class="col-sm-4 projects-info-item">
														<i class="fa fa-cubes fa-fw fa-2x pull-left hidden-xs info-icons" style="margin-top: 8px;"></i>
														<label class="control-label" for="nb-of-applications">Projects</label>
														<div
															id="nb-of-applications"
															:class="{'max-value-reached': getMyProjectsCount > authUserStore.subscription.apps}"
															class="list-group-item-text"
														>{{getMyProjectsCount}}/{{authUserStore.subscription.apps}}</div>
													</div>

													<div class="col-sm-4 projects-info-item">
														<MauCounter :mau="authUserStore.mau.count" :max-value="authUserStore.subscription.mau" />
													</div>

													<div class="col-sm-4 projects-info-item">
														<i
															v-on:click="goToTeamsPage()"
															class="fa fa-users fa-fw fa-2x pull-left hidden-xs clickable info-icons"
															style="margin-top: 8px;"
														></i>
														<label
															class="control-label clickable"
															v-on:click="goToTeamsPage()"
															for="nb-of-users"
														>Team Members</label>
														<div
															id="nb-of-users"
															v-on:click="goToTeamsPage()"
															:class="{'max-value-reached': getMembersCount() > authUserStore.subscription.teamMembers}"
															class="list-group-item-text clickable"
														>{{ getMembersCount() }}/{{ authUserStore.subscription.teamMembers }}</div>
													</div>

												</div>

											</div>

											<div class="col-lg-6">
												
												<!-- Info -->
												<div class="row">

													<div class="col-sm-4 projects-info-item">
														<i class="fa fa-usd fa-fw fa-2x pull-left hidden-xs mg-top-8 info-icons"></i>
														<label
															class="control-label"
															for="current-tier"
														>Current Tier</label>
														<div
															id="current-tier"
															class="list-group-item-text"
														>
															{{authUserStore.subscription.name}}
															<span
																class="btn btn-primary btn-sm upgrade-button"
																v-if="getMembersCount() > authUserStore.subscription.teamMembers || authUserStore.mau.count > authUserStore.subscription.mau"
															>Upgrade</span>
														</div>
													</div>

													<!-- Mt words count -->
													<div class="col-sm-4 projects-info-item" v-tooltip.top="!isMtEnabled ? featureDisabledTooltip : undefined">
														<i class="fas pull-left fa-language mg-top-8 mg-right-7 font-size-32 info-icons" :class="{'disabled': !isMtEnabled}"></i>
														<div class="display-flex flex-direction-column gap-5" :class="{'disabled': !isMtEnabled}">
															<span class="font-weight-400">MT Words</span>
															<span
																v-if="isMtEnabled"
																:class="{'max-value-reached': maxMtReached }"
															>{{ mtCount }} / {{ mtLimit }}</span>
															<span v-if="!isMtEnabled && mtCount === 0">&#x1F6AB;</span>
															<span v-if="!isMtEnabled && mtCount > 0">{{ mtCount }} / 0</span>
														</div>
													</div>

													<!-- Ai count -->
													<div class="col-sm-4 projects-info-item" v-tooltip.top="!isAiEnabled ? featureDisabledTooltip : undefined">
														<i class="fas pull-left fa-magic mg-top-8 mg-right-7 font-size-32 info-icons" :class="{'disabled': !isAiEnabled}"></i>
														<div class="display-flex flex-direction-column gap-5" :class="{'disabled': !isAiEnabled}">
															<span class="font-weight-400">AI Tokens</span>
															<span
																v-if="isAiEnabled"
																:class="{'max-value-reached': maxAiReached }"
															>{{ aiCount }} / {{ aiLimit }}</span>
															<span v-if="!isAiEnabled && aiCount === 0 ">&#x1F6AB;</span>
															<span v-if="!isAiEnabled && aiCount > 0">{{ aiCount }} / 0</span>
														</div>
													</div>

												</div>

											</div>

										</div>
									</div>
								</div>
							</div>
						</div>
						
						<button class="app-add btn btn-primary"  v-on:click="addProject()">
							<div class="button-text">
								<i class="glyphicon glyphicon-plus"></i>
								Add Project
							</div>
						</button>
					</div>

					<div class="spinner-wrapper" v-show="isLoading">
						<div class="spinner">
							<div class="dot1"></div>
							<div class="dot2"></div>
						</div>

						<div class="loading-text">Loading</div>
					</div>

					<div class="languages-wrapper">
						<div class="list-group">
							<ProjectQuickInfo v-for="project in myProjects" :key="project._id" :project="project" />
							<nav
								v-if="getMyProjectsCount > projectsListPagesConfig.myMobileApps.size"
								aria-label="Page navigation example"
							>
								<ul class="pagination" style="margin-bottom: 0;">
									<li
										class="page-item"
										:class="{disabled: disablePrevButton(projectsListsType.myMobileApps)}"
									>
										<a
											class="page-link"
											v-on:click="goToProjectsPage(projectsListsType.myMobileApps, projectsListPagesConfig.myMobileApps.current - 1)"
										>Previous</a>
									</li>
									<li
										v-for="page in getProjectsPages(projectsListsType.myMobileApps, getMyProjectsCount)"
										:key="page"
										class="page-item"
										:class="{active: projectsListPagesConfig.myMobileApps.current === page}"
									>
										<a
											class="page-link"
											v-on:click="goToProjectsPage(projectsListsType.myMobileApps, page)"
										>{{page}}</a>
									</li>
									<li
										class="page-item"
										:class="{disabled: disableNextButton(projectsListsType.myMobileApps)}"
									>
										<a
											class="page-link"
											v-on:click="goToProjectsPage(projectsListsType.myMobileApps, projectsListPagesConfig.myMobileApps.current + 1)"
										>Next</a>
									</li>
								</ul>
							</nav>
						</div>
						<div class="alert alert-warning text-center" v-show="!getMyProjectsCount">
							No projects yet, why don't you
							<router-link :to="{ name: 'createProject'}">
								add one
							</router-link>?
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			v-if="sharedProjects.length"
			class="panel panel-blue padding-10-firefox"
			style="clear: both;margin-top:90px;"
		>
			<PanelHeading
				id="sharedApps"
				:title="'Shared Projects'"
			>
				<SortingListButton 
					:options="sortingOptions"
					:sortKey="projectsListPagesConfig.sharedApps.sortKey"
					:orderDesc="projectsListPagesConfig.sharedApps.orderDesc"
					class="pull-right"
					v-on:sortOrderChanged="changeSortOrder(projectsListsType.sharedApps, $event)"
				/>
			</PanelHeading>
			<div class="panel-content">
				<div class="panel-body" :class="{loading: !isLoading}">
					<div class="spinner-wrapper" v-show="isLoading">
						<div class="spinner">
							<div class="dot1"></div>
							<div class="dot2"></div>
						</div>

						<div class="loading-text">Loading</div>
					</div>

					<div class="languages-wrapper">
						<div class="list-group">
							<ProjectQuickInfo v-for="project in sharedProjects" :key="project._id" :project="project" />
							<nav
								v-if="getSharedProjectsCount > projectsListPagesConfig.sharedApps.size"
								aria-label="Page navigation example"
							>
								<ul class="pagination" style="margin-bottom: 0;">
									<li class="page-item" :class="{disabled: disablePrevButton(projectsListsType.sharedApps)}">
										<a
											class="page-link"
											v-on:click="goToProjectsPage(projectsListsType.sharedApps, projectsListPagesConfig.sharedApps.current - 1)"
										>Previous</a>
									</li>
									<li
										v-for="page in getProjectsPages(projectsListsType.sharedApps, getSharedProjectsCount)"
										:key="page"
										class="page-item"
										:class="{active: projectsListPagesConfig.sharedApps.current === page}"
									>
										<a
											class="page-link"
											v-on:click="goToProjectsPage(projectsListsType.sharedApps, page)"
										>{{page}}</a>
									</li>
									<li class="page-item" :class="{disabled: disableNextButton(projectsListsType.sharedApps)}">
										<a
											class="page-link"
											v-on:click="goToProjectsPage(projectsListsType.sharedApps, projectsListPagesConfig.sharedApps.current + 1)"
										>Next</a>
									</li>
								</ul>
							</nav>
						</div>
					</div>
				</div>
			</div>
		</div>
		<ApplangaTutorial
			v-if="!whitelabel"
			:tutorial-title="'Project Overview Help'"
			:templateKey="TUTORIAL_TEMPLATES_KEYS.listMobileApps"
			:isOpenTutorial="noAppCreated"
		/>
	</div>
</template>

<script>
// Global Components
import ApplangaTutorial from '@/components/ApplangaTutorial';
import MauCounter from '@/components/MauCounter';
import PanelHeading from '@/components/PanelHeading';
import ProjectQuickInfo from '@/components/ProjectQuickInfo';
import SortingListButton from '@/components/SortingListButton';

// Mixins
import { ToastMixin } from '@/mixins/Toast';

// Stores
import { useAuthUserStore } from '@/stores/authUser';

// Services
import { TUTORIAL_TEMPLATES_KEYS } from '@/services/User';

export default {
	mixins: [
		ToastMixin
	],
	components: {
		ApplangaTutorial,
		MauCounter,
		PanelHeading,
		ProjectQuickInfo,
		SortingListButton
	},
	data() {
		return {
			authUserStore: useAuthUserStore(),
			TUTORIAL_TEMPLATES_KEYS,
			projects: [],
			projectsListsType: {
				myMobileApps: 'myMobileApps',
				sharedApps: 'sharedApps'
			},
			sortingOptions: [
				{
					sortKey: 'name',
					name: 'Name',
					reverse: false //defult sort order is ascending
				},
				{
					sortKey: '_id',
					name: 'Creation Date',
					reverse: true //defult sort order is descending
				}
			],
			projectsListPagesConfig: {
				myMobileApps: {
					current: 1,
					size: 20,
					total: 0,
					sortKey: '_id',
					orderDesc: true
				},
				sharedApps: {
					current: 1,
					size: 20,
					total: 0,
					sortKey: '_id',
					orderDesc: true
				}
			},
			myProjects: {},
			sharedProjects: [],
			noAppCreated: false,
			isLoading: false,
			whitelabel: false,
			featureDisabledTooltip: 'Not included in your tier. Please reach out to upgrade your subscription'
		};
	},
	computed: {
		getMyProjectsCount() {
			return this.projectsListPagesConfig.myMobileApps.total;
		},
		getSharedProjectsCount() {
			return this.projectsListPagesConfig.sharedApps.total;
		},
		isAiEnabled() {
			return !!this.aiLimit;
		},
		isMtEnabled() {
			return !!this.mtLimit;
		},
		aiCount () {
			if(!this.authUserStore.aiCount) return 0;
			return this.authUserStore.aiCount.count;
		},
		mtCount () {
			if(!this.authUserStore.mtWords) return 0;
			return this.authUserStore.mtWords.count;
		},
		mtLimit: function() {
			return (this.authUserStore.subscription && this.authUserStore.subscription.mtWordLimit) || 0;
		},
		aiLimit: function() {
			return (this.authUserStore.subscription && this.authUserStore.subscription.aiTokenLimit) || 0;
		},
		maxMtReached() {
			return this.mtLimit <= this.mtCount;
		},
		maxAiReached() {
			return this.aiLimit <= this.aiCount;
		}
	},
	methods: {
		addProject: function() {
			this.$router.push({name: 'createProject'});
		},
		goToTeamsPage: function() {
			this.$router.push({name: 'listTeams'});
		},
		changeSortOrder(projectsListType, sortOrder){
			this.projectsListPagesConfig[projectsListType].sortKey = sortOrder.sortKey;
			this.projectsListPagesConfig[projectsListType].orderDesc = sortOrder.orderDesc;
			this.goToProjectsPage(projectsListType, 1);
		},
		goToProjectsPage: function(projectsListType, page) {
			this.projectsListPagesConfig[projectsListType].current = page;
			setTimeout(() => {
			$('html,body').animate(
				{
					scrollTop:
						$('#' + projectsListType).offset().top - $('header').height()
				},
				'normal'
			);
			}, 350);
			this.getProjectsByPage();
		},
		getMtCount: function() {
			if(!this.authUserStore.mtWords) return 0;

			return this.authUserStore.mtWords.count;
		},
		getMembersCount: function() {
			if (!this.authUserStore.teamMembers) {
				return 0;
			}

			let members = this.authUserStore.teamMembers.filter((m) => {
				return m && m.role && !m.role.toLowerCase().includes('tpt') && m.email !== 'superadmin@applanga.com';
			});

			return members ? members.length : 0;
		},
		getProjectsPages: function(projectsListType, total) {
			let pages = [];
			let page = 1;
			let pageCounter = 1;
			let pageSize = this.projectsListPagesConfig[projectsListType].size;
			for (let index = 1; index <= total; index++) {
				if (
					pageCounter === pageSize ||
					(index === total && index !== pages.length * pageSize)
				) {
					pages.push(page++);
					pageCounter = 1;
				}
				pageCounter++;
			}

			return pages;
		},
		disablePrevButton: function(projectsListType) {
			return this.projectsListPagesConfig[projectsListType].current === 1;
		},
		disableNextButton: function(projectsListType) {
			return (
				this.getProjectsPages(
					projectsListType,
					this.projectsListPagesConfig[projectsListType].total
				).length === this.projectsListPagesConfig[projectsListType].current
			);
		},
		checkUrlRedirection: function(){
			const originURL = window.location.origin + window.location.pathname,
			expectedURL = `${originURL}#/projects`,
			actualURL = window.location.href.split('?')[0],
			isNotExpectedURL = (actualURL.length !== expectedURL.length),
			isLoadProjectError = this.$route.query.loadProjectError,
			replaceUrl = () => {
				location.replace(expectedURL);
			}

			switch (true) {
				case isNotExpectedURL:
					replaceUrl();
					return;

				case isLoadProjectError:
					replaceUrl();
					this.toastError('Project could not be loaded!');
					return;
			
				default:
					return;
			}
		},
		getProjectsByPage: async function() {
			try {
				let projectsByPage = await this.authUserStore.getUserProjectsByPage(this.projectsListPagesConfig);

				if (projectsByPage.mobileApps.length === 0 && projectsByPage.sharedApps.length === 0) {
						this.noAppCreated = true;
						this.$router.push({name: 'createProject'});
						return;
					}

					this.myProjects = projectsByPage.mobileApps || [];
					this.sharedProjects = projectsByPage.sharedApps || [];
					this.projects = this.myProjects.concat(this.sharedProjects) || [];

					this.projectsListPagesConfig.myMobileApps.total =
						projectsByPage.mobileAppsCount;
					this.projectsListPagesConfig.sharedApps.total =
						projectsByPage.sharedAppsCount;

					this.projects.forEach((project) => {
			
						// Add the role of the current users on the project
						project.roleInApp = 'none';
						if (project.team && project.team.members) {
							for (let i = 0; i < project.team.members.length; i++) {
								if (this.authUserStore._id === project.team.members[i].user) {
									project.roleInApp = project.team.members[i].role;
									break;
								}
							}
						}
					});
			} catch (err) {
				return Promise.reject(err);
			}
		},
		loadUserSubscription: async function() {
			try {
				await this.authUserStore.getUserPlan();
			} catch (err) {
				return Promise.reject(err);
			}
		},
		loadUserTeamMembers: async function() {
			try {
				await this.authUserStore.getUserTeamMembers();
			} catch (err) {
				return Promise.reject(err);
			}
		},
		loadMau: async function() {
			await this.authUserStore.getUserMau();
		},
		loadAiCount: async function() {
			await this.authUserStore.getUserAiCount();
		},
		loadMtWords: async function() {
			await this.authUserStore.getUserMtWords();
		},
		init: async function() {
			this.checkUrlRedirection();
			
			this.isLoading = true;

			try {
				await Promise.all([
					this.getProjectsByPage(),
					this.loadUserSubscription(),
					this.loadUserTeamMembers(),
					this.loadMau(),
					this.loadMtWords(),
					this.loadAiCount()
				]);
			}
			catch (err) {
				return Promise.reject(err);
			}
			
			this.isLoading = false;
		}
	},
	mounted: function() {
		if (this.authUserStore.softErrorMessage) {
			this.toastWarning(this.authUserStore.softErrorMessage);
			this.authUserStore.clearErrorMessage();
		}
	},
	created: function() {
		this.init();
	}
};
</script>

<style scoped>
.projects-info-item {
	margin: 15px 0;
}
.projects-info-item::v-deep .info-icons,
.info-icons {
    color: #677188;
    position: relative;
    right: 5px;
}
</style>